import { NavLink } from 'react-router-dom';

import Logo from '../../assets/logo.png';

import { ROUTES } from '../../config/routes';
import Container from '../Container';
import { useAppContext } from '../../context/AppContext';

import Typography from '@mui/joy/Typography';

import './AppHeader.css';

const AppHeader = ({ showHeader }) => {
  const { andee, cart } = useAppContext();
  // const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  // const showMobileMenu = window.innerWidth < 768
  const showMobileMenu = false;

  const authenticatedLinks = [
    { url: ROUTES.MARKETPLACE, text: 'Marketplace' },
    { url: ROUTES.CART, text: 'Cart' },
    { url: ROUTES.ACCOUNT, text: 'Account' },
    { url: ROUTES.LOGOUT, text: 'Logout' },
  ];
  // const unauthenticatedLinks = [
  //   { url: ROUTES.HOME, text: "Home" },
  //   { url: ROUTES.MARKETPLACE, text: "Marketplace" },
  //   { url: ROUTES.LOGIN, text: "Login" },
  // ]

  const renderNavLinks = () => {
    const links = andee ? authenticatedLinks : [];

    return links.length ? (
      <Typography>
        <ul className="nav__links">
          {
            links.map(link => {
              if (link.text === 'Cart' && !cart.tags?.length) {
                return (<li key={link.url} className={'nav__list-item '}>
                  <p className="nav__link nav__link--inactive">{link.text}</p>
                </li>);
              }
              return (
                <li key={link.url} className={'nav__list-item'}>
                  <NavLink
                    to={link.url}
                    className={[
                      'nav__link',
                      link.url === window.location.pathname ? 'nav__link--current' : ''
                    ].join(' ')}
                  >{link.text}</NavLink>
                </li>
              );
            })
          }
        </ul>
      </Typography>
    ) : null;
  };

  return (
    showHeader && (<header id={'AppHeader'}>
      <Container>
        {showMobileMenu && (
          <nav>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                paddingTop: 10,
              }}
            >
              <NavLink to={ROUTES.HOME}>
                <img src={Logo} alt={'& Logo'} width={60} />
              </NavLink>
              {/* <FontAwesomeIcon
                icon={faBars}
                style={{ color: "#2c2c2c", fontSize: 25 }}
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              /> */}
            </div>
            {/* {mobileMenuOpen && renderNavLinks()} */}
          </nav>
        )}
        {showMobileMenu === false && (
          <nav style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
            <NavLink to={ROUTES.HOME}>
              <img src={Logo} alt={'& Logo'} width={80} style={{ marginTop: 10 }} />
            </NavLink>
            {renderNavLinks()}
          </nav>
        )}
      </Container>
    </header>)
  );
};

export default AppHeader;
